<template>
  <div
    class="flex flex-col w-full text-left h-auto"
    :class="[bordered && 'border-primary border-t-4']"
  >
    <div
      :class="['h-full bg-no-repeat bg-cover bg-center']"
      :style="background ? `background-image: url(${background});` : 'background: #2F3337'"
    >
      <div class="h-full w-full bg-black bg-opacity-85 flex flex-col p-6">
        <div class="text-left mb-12">
          <slot name="subtitle">
            <Subtitle :subtitle="subtitle" />
          </slot>
          <slot name="title">
            <Title :title="title" />
          </slot>
          <slot name="body">
            <Body :body="body" />
          </slot>
        </div>
        <div class="mt-auto">
          <slot name="action" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Title, Subtitle,  Body } from '@/components/atoms/Card';

export default {
  name: 'Card',
  components: {
    Title,
    Subtitle,
    Body
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default: () => []
    },
    body: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: null
    },
    bordered: {
      type: Boolean,
      default: false
    }
  }
};
</script>
